// extracted by mini-css-extract-plugin
export var actionButton = "_fo-0";
export var attachmentLine = "_fo-1";
export var fileInput = "_fo-2";
export var fileUploadWrapper = "_fo-4";
export var footer = "_fo-3";
export var modalContent = "_fo-5";
export var paperclip = "_fo-6";
export var quillEditor = "_fo-7";